import { watch, type App } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import router from '@/app/router'
import { ensureCurrentUser } from '@/features/auth/queries/ensureCurrentUser'
import { i18n } from '@/i18n'
import { queryClient } from '@/lib/api/queryClient'
import { useAuthStore } from '@/stores/auth'

export function registerProviders(app: App): void {
  app.use(createPinia())
  app.use(router)

  // Any sign-out (manual, expired token/401, account deletion) lands on /login.
  const auth = useAuthStore()
  watch(
    () => auth.isAuthenticated,
    (isAuthenticated) => {
      if (!isAuthenticated && router.currentRoute.value.path !== '/login') router.push('/login')
    },
  )

  // Refresh the persisted user (roles included) at startup and after every sign-in.
  watch(
    () => auth.isAuthenticated,
    (isAuthenticated) => {
      if (isAuthenticated) ensureCurrentUser().catch(() => undefined)
    },
    { immediate: true },
  )

  app.use(i18n)
  app.use(VueQueryPlugin, { queryClient })
}
